const VendorKeyActions = {
  LOADED: "vendor-key/loaded",
  UPDATED: "vendor-key/updated",
  LIST_LOADED: "vendor-keys/loaded",
  LIST_CHANGED: "vendor-keys/changed",
};

export default VendorKeyActions;
